import { useQuery } from '@apollo/client';
import { useContext } from 'react';
import { UserContext } from '../../auth/UserContext';
import { FETCH_POLICY_CONFIG } from '../../constants/constants';
import { client, getNote } from './notesGraphqlApi';

export const useGetNote = (id: string, skip: boolean) => {
    const { activeOrganizationAccount } = useContext(UserContext);

    const {
        data: noteDetails,
        loading: isNoteLoading,
        error: noteFetchError,
        refetch: noteRefetch
    } = useQuery(getNote, {
        variables: {
            id
        },
        context: {
            headers: {
                ownerId: activeOrganizationAccount
            }
        },
        client,
        fetchPolicy: FETCH_POLICY_CONFIG.apolloFetchPolicy,
        notifyOnNetworkStatusChange: true,
        skip
    });

    return { noteDetails, isNoteLoading, noteFetchError, noteRefetch };
};
